const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const IconGear = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 3.5v2.2M12 18.3v2.2M20.5 12h-2.2M5.7 12H3.5M17.7 6.3l-1.55 1.55M7.85 16.15 6.3 17.7M17.7 17.7l-1.55-1.55M7.85 7.85 6.3 6.3" />
  </svg>
);

export const IconMonitor = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="4.5" width="18" height="12" rx="1.6" />
    <path d="M8 20h8M12 16.5V20" />
    <path d="M7 9.5l2.5 2.5L7 14.5M13 14.5h4" />
  </svg>
);

export const IconHeadset = (p) => (
  <svg {...base} {...p}>
    <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
    <rect x="3" y="13" width="4" height="6" rx="1.4" />
    <rect x="17" y="13" width="4" height="6" rx="1.4" />
    <path d="M19 19v.5A2.5 2.5 0 0 1 16.5 22H13" />
  </svg>
);

export const IconClipboard = (p) => (
  <svg {...base} {...p}>
    <rect x="6" y="4.5" width="12" height="16" rx="1.6" />
    <path d="M9 4.5V3.8A1.8 1.8 0 0 1 10.8 2h2.4A1.8 1.8 0 0 1 15 3.8v.7" />
    <path d="M9 11h6M9 15h6M9 19h4" />
  </svg>
);

export const IconGlobe = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17M12 3.5c2.4 2.4 3.7 5.3 3.7 8.5s-1.3 6.1-3.7 8.5c-2.4-2.4-3.7-5.3-3.7-8.5S9.6 5.9 12 3.5Z" />
  </svg>
);

export const IconCloud = (p) => (
  <svg {...base} {...p}>
    <path d="M7.2 18.5a4.2 4.2 0 0 1-.4-8.38 5.4 5.4 0 0 1 10.5-1.7 4.3 4.3 0 0 1-.8 10.08H7.2Z" />
  </svg>
);

export const IconDatabase = (p) => (
  <svg {...base} {...p}>
    <ellipse cx="12" cy="6" rx="7.5" ry="3" />
    <path d="M4.5 6v12c0 1.66 3.36 3 7.5 3s7.5-1.34 7.5-3V6" />
    <path d="M4.5 12c0 1.66 3.36 3 7.5 3s7.5-1.34 7.5-3" />
  </svg>
);

export const IconChat = (p) => (
  <svg {...base} {...p}>
    <path d="M4 12a8 7 0 1 1 3.2 5.6L4 19l1.1-3.2A6.9 6.9 0 0 1 4 12Z" />
    <path d="M9 11.2h6M9 14h4" />
  </svg>
);

export const IconShield = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.2 19 6v5.4c0 4.6-2.9 7.6-7 9.4-4.1-1.8-7-4.8-7-9.4V6l7-2.8Z" />
    <path d="M9 12.2l2 2 4-4.2" />
  </svg>
);

export const IconChart = (p) => (
  <svg {...base} {...p}>
    <path d="M4 20V9M9.5 20V4M15 20v-7M20.5 20V11" />
    <path d="M3.5 20.5h17" />
  </svg>
);

export const IconLink = (p) => (
  <svg {...base} {...p}>
    <path d="M9.5 14.5 14.5 9.5" />
    <path d="M11 6.3l1-1a3.6 3.6 0 0 1 5.1 5.1l-1.4 1.4M13 17.7l-1 1a3.6 3.6 0 0 1-5.1-5.1l1.4-1.4" />
  </svg>
);

export const IconClock = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7v5.2l3.6 2.1" />
  </svg>
);

/* Adicionar estes três ao final do Icons.jsx existente */

export const IconTarget = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="4.8" />
    <circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconRocket = (p) => (
  <svg {...base} {...p}>
    <path d="M12 2.8c2.6 1.9 4.2 5 4.2 8.4 0 2-.5 3.7-1.3 5.1l-2.9 3.4-2.9-3.4C8.3 14.9 7.8 13.2 7.8 11.2c0-3.4 1.6-6.5 4.2-8.4Z" />
    <circle cx="12" cy="10.5" r="1.9" />
    <path d="M8.4 16.5 6 19M15.6 16.5 18 19M10.2 20.5h3.6" />
  </svg>
);

export const IconBulb = (p) => (
  <svg {...base} {...p}>
    <path d="M8.2 14.5A5.3 5.3 0 1 1 15.8 14.5c-.7.8-1.3 1.6-1.3 2.6v.4H9.5v-.4c0-1-.6-1.8-1.3-2.6Z" />
    <path d="M9.7 20h4.6M10.3 17.5h3.4" />
  </svg>
);

export const IconX = (p) => (
  <svg {...base} {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const IconCheck = (p) => (
  <svg {...base} {...p}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);

export const IconWindows = (p) => (
  <svg {...base} {...p}>
    <rect x="3.5" y="3.5" width="7.2" height="7.2" rx="1" />
    <rect x="13.3" y="3.5" width="7.2" height="7.2" rx="1" />
    <rect x="3.5" y="13.3" width="7.2" height="7.2" rx="1" />
    <rect x="13.3" y="13.3" width="7.2" height="7.2" rx="1" />
  </svg>
);

export const IconApple = (p) => (
  <svg {...base} {...p} fill="currentColor" stroke="none">
    <path d="M15.6 3.3c.1 1-.3 2-.9 2.8-.6.8-1.6 1.4-2.6 1.3-.1-1 .4-2.1 1-2.7.7-.8 1.8-1.3 2.5-1.4Z" />
    <path d="M18.9 16.9c-.4.9-.8 1.7-1.4 2.5-.8 1.1-1.6 2.2-2.9 2.2-1.2 0-1.6-.8-3-.8-1.4 0-1.9.8-3 .8-1.2 0-2.1-1.2-2.9-2.3-1.6-2.2-2.8-6.2-1.2-9 .8-1.4 2.2-2.2 3.6-2.2 1.2 0 2.2.8 2.9.8.7 0 1.9-1 3.3-.9.6 0 2.2.2 3.2 1.7-.1.1-1.9 1.1-1.9 3.3 0 2.6 2.3 3.5 2.3 3.5Z" />
  </svg>
);

export const IconTerminal = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="4.5" width="18" height="15" rx="2" />
    <path d="M7 9.5l3 2.7-3 2.7M12.5 15h4.5" />
  </svg>
);

export const IconSmartphone = (p) => (
  <svg {...base} {...p}>
    <rect x="6.5" y="2.5" width="11" height="19" rx="2.2" />
    <path d="M10.5 18.3h3" />
  </svg>
);

export const IconDownload = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.5v11.3M8 11.2l4 4 4-4" />
    <path d="M4.5 17v2a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-2" />
  </svg>
);

export const IconAlertTriangle = (p) => (
  <svg {...base} {...p}>
    <path d="M12 4 21.2 20H2.8L12 4Z" />
    <path d="M12 10v4.5" />
    <circle cx="12" cy="17.6" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const IconPrinter = (p) => (
  <svg {...base} {...p}>
    <rect x="5" y="8.5" width="14" height="7.5" rx="1.4" />
    <path d="M7 8.5V4.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4" />
    <rect x="7.5" y="14.5" width="9" height="6" rx="1" />
    <path d="M8.5 12h1" />
  </svg>
);

export const IconMail = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="M4 7l8 6 8-6" />
  </svg>
);

export const IconWrench = (p) => (
  <svg {...base} {...p}>
    <path d="M14.5 6.5a4 4 0 0 0-5.4 4.9L4 16.5l3 3 5.1-5.1a4 4 0 0 0 4.9-5.4l-2.6 2.6-2.1-.6-.6-2.1 2.8-2.4Z" />
  </svg>
);

export const IconBox = (p) => (
  <svg {...base} {...p}>
    <path d="M3.5 8 12 3.5 20.5 8 12 12.5 3.5 8Z" />
    <path d="M3.5 8v8L12 20.5 20.5 16V8" />
    <path d="M12 12.5v8" />
  </svg>
);

export const IconCoin = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.3v9.4M9.6 9.3c0-1.1 1.1-1.8 2.4-1.8s2.4.7 2.4 1.7c0 2.4-4.8 1-4.8 3.4 0 1 1.1 1.8 2.4 1.8s2.4-.7 2.4-1.7" />
  </svg>
);

export const IconBook = (p) => (
  <svg {...base} {...p}>
    <path d="M4 5.5c2-1.3 4.7-1.3 8 0v13c-3.3-1.3-6-1.3-8 0v-13Z" />
    <path d="M20 5.5c-2-1.3-4.7-1.3-8 0v13c3.3-1.3 6-1.3 8 0v-13Z" />
  </svg>
);

export const IconHelp = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9.6 9.3c0-1.3 1.1-2.3 2.5-2.3s2.5.9 2.5 2.1c0 2.3-2.6 2-2.6 4.2" />
    <circle cx="12" cy="16.8" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const IconMapPin = (p) => (
  <svg {...base} {...p}>
    <path d="M12 21.5s7-6.4 7-12A7 7 0 0 0 5 9.5c0 5.6 7 12 7 12Z" />
    <circle cx="12" cy="9.5" r="2.4" />
  </svg>
);

export const IconLock = (p) => (
  <svg {...base} {...p}>
    <rect x="5" y="10.5" width="14" height="10" rx="2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
  </svg>
);

export const IconTicket = (p) => (
  <svg {...base} {...p}>
    <path d="M4 8.5A2 2 0 0 1 6 6.5h12a2 2 0 0 1 2 2v2a1.8 1.8 0 0 0 0 3v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1.8 1.8 0 0 0 0-3v-2Z" />
    <path d="M14.5 6.5v11" strokeDasharray="2 2.5" />
  </svg>
);

export const IconCreditCard = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="M3 9.5h18" />
    <path d="M6.5 14.5h5" />
  </svg>
);
